import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class AlertasService {
  constructor(private messageService: MessageService) {}

  // public mostrarAlerta(
  //   severity: "success" | "info" | "warn" | "error",
  //   summary?: string,
  //   detail?: string,
  //   life = 10000
  // ) {
  //   this.messageService.add({
  //     severity,
  //     summary,
  //     detail,
  //     life,
  //   });
  // }

  public mostrarAlerta(
    severity: "success" | "info" | "warn" | "error",
    summary?: string,
    detail?: string,
    life = 10000
  ) {
    Swal.fire({
      title: summary,
      showConfirmButton: false,
      timer: life,
      position: "top-end",
      text: detail,
      type: severity === "warn" ? "warning" : severity,
    });
  }
}
